import { render, staticRenderFns } from "./EmptyCart.vue?vue&type=template&id=f6421772"
import script from "./EmptyCart.vue?vue&type=script&lang=ts"
export * from "./EmptyCart.vue?vue&type=script&lang=ts"
import style0 from "./EmptyCart.vue?vue&type=style&index=0&id=f6421772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports